import { Box, Divider, Text, Title } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ApprovalsInformationBlock from 'modules/approvals/components/ApprovalsInformationBlock'

import { ApprovalData } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/BasePendingApprovals/types'

interface Props {
  collapseContentData: ApprovalData
}

const BasicInformationApproval = ({ collapseContentData }: Props) => {
  return (
    <Box flexDirection="row" gap="s40" width="full">
      <Box width="full" gap="s24">
        <Title
          variant="400"
          illustration="template"
          title={i18n.t('common.basic_information')}
          description=""
        />

        <Box>
          <Text.Normal weight="medium" color="grey1000">
            {i18n.t('dashboard.todo.approvals.general.request')}
          </Text.Normal>
          <Text.Normal>{i18n.t('dashboard.todo.approvals.general.description')}</Text.Normal>
        </Box>

        <ApprovalsInformationBlock
          resourceId={collapseContentData.approvalFlow.resourceId}
          resourceType={collapseContentData.approvalFlow.resourceType}
        />
      </Box>
      <Divider vertical />
    </Box>
  )
}

export default BasicInformationApproval
